import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getMainMarketModels } from '../services/mainMarket';

export const mainMarketApi = createApi({
    reducerPath: 'mainMarketApi',
    baseQuery: fetchBaseQuery({ baseUrl: '/mainMarket' }),
    endpoints: (builder) => ({
        getMainMarketModels: builder.query<any[], void>({
            queryFn: async () => {
                try {
                    const result = await getMainMarketModels();
                    return { data: result };
                } catch (error) {
                    return { error: error.message || 'Failed to fetch main market models' };
                }
            },
        }),
    }),
});

export const useGetMainMarketModels = mainMarketApi.endpoints.getMainMarketModels.useQuery;
